<mat-form-field *ngIf="type==='float'">
    <mat-placeholder>
        {{label}}
    </mat-placeholder>
    <input #inputElement
           matInput
           autocomplete="off"
           [(ngModel)]="addressValue"
           [disabled]="disabled || !!value"
           [required]="isRequired">
    <mat-icon class="clear-icon" *ngIf="!!value" (click)="clear()">clear</mat-icon>
</mat-form-field>

<ig-field *ngIf="type==='text'" #inputElement
          [label]="label"
          [placeholder]="placeholder"
          [required]="isRequired"
          [disabled]="disabled"
          [icon]="!!value?'clear':'room'"
          (onIconClick)="clear()"
          [isInnerLabel]="innerLabel"
          [formControl]="locationFormGroup.get('address')"
          [(ngModel)]="addressValue">
</ig-field>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/city.selector/city.selector.component.html